var mode = "development"

export function Log(value) {
   if (mode === "development") {
   }
}
